import React from 'react'
import { FormattedMessage } from '@dragonraider5/react-intl'
import { Link } from 'react-router-dom'
import { getExceptionMessage } from '../../utils/exceptions'
import { LOGIN_PATH } from '../MainRoutes/constants'
import { SectionWrapper } from '../../components/Section'
import H1 from '../../components/H1'
import Button from '../../components/Button'
import SuccessMessage from '../../components/SuccessMessage'
import messages from './messages';

function AccountVerificationFailure({ error }) {
  return (
    <SectionWrapper align='center'>
      <H1>
        <FormattedMessage {...messages.title} />
      </H1>
      <SuccessMessage trailer>
        <FormattedMessage {...getExceptionMessage(error)} />
      </SuccessMessage>
      <Button as={Link} to={LOGIN_PATH}>
        <FormattedMessage {...messages.loginButton} />
      </Button>
    </SectionWrapper>
  )
}

export default AccountVerificationFailure
